export const COLORS = {
  PRIMARY: '#00d4ff',
  SECONDARY: '#ff6b9d',
  ACCENT: '#ffd166',
  SUBTITLE: '#4fc3f7',
  BACKGROUND: '#0a0a0f',
  TEXT_PRIMARY: '#e8e8e8',
  TEXT_SECONDARY: 'rgba(255, 255, 255, 0.7)',
};

export const DART_GAME = {
  DART_SIZE: 16,
  MAX_PULL: 110,
  POWER_SCALE: 18,
  GRAVITY: 1800,
  MAX_FLIGHT_TIME: 3,
  COLLISION_RADIUS: 40,
  MIN_DRAG_DISTANCE: 12,
  MIN_AIM_DISTANCE: 8,
};

export const SCENE_ANIMATION = {
  ROTATION_Y: {
    FREQUENCY_1: 0.3,
    AMPLITUDE_1: 0.05,
    FREQUENCY_2: 0.47,
    AMPLITUDE_2: 0.03,
    FREQUENCY_3: 0.23,
    AMPLITUDE_3: 0.02,
  },
  POSITION_Y: {
    FREQUENCY_1: 0.4,
    AMPLITUDE_1: 0.02,
    FREQUENCY_2: 0.57,
    AMPLITUDE_2: -0.5,
    FREQUENCY_3: 0.31,
    AMPLITUDE_3: 0.01,
  },
  ROTATION_X: {
    FREQUENCY_1: 0.35,
    AMPLITUDE_1: 0.2,
    FREQUENCY_2: 0.19,
    AMPLITUDE_2: 0.015,
  },
};

export const TEXT_3D_CONFIG = {
  FONT_PATH: '/fonts/optimer_regular.typeface.json',
  MAIN_TITLE: {
    SIZE: 0.6,
    HEIGHT: 0.15,
    BEVEL_THICKNESS: 0.015,
    BEVEL_SIZE: 0.02,
    BEVEL_SEGMENTS: 5,
    CURVE_SEGMENTS: 12,
    POSITION: [0, 0.3, 0],
    SHADOW_POSITION: [0.02, 0.27, -0.02],
  },
  SUBTITLE: {
    SIZE: 0.3,
    HEIGHT: 0.08,
    BEVEL_THICKNESS: 0.01,
    BEVEL_SIZE: 0.01,
    BEVEL_SEGMENTS: 3,
    CURVE_SEGMENTS: 8,
    POSITION: [0.05, -0.2, 0],
  },
};

export const CANVAS_CONFIG = {
  CAMERA: {
    POSITION: [0, 0, 5],
    FOV: 50,
  },
  LIGHTS: {
    AMBIENT: { intensity: 0.4 },
    DIRECTIONAL_1: {
      position: [5, 5, 5],
      intensity: 1.2,
      castShadow: true,
    },
    DIRECTIONAL_2: {
      position: [-5, 3, -5],
      intensity: 0.5,
      color: COLORS.SECONDARY,
    },
    POINT: {
      position: [0, -2, 4],
      intensity: 0.8,
      color: COLORS.SUBTITLE,
    },
  },
  ORBIT_CONTROLS: {
    enableZoom: true,
    enablePan: false,
    enableDamping: true,
    dampingFactor: 0.05,
    rotateSpeed: 0.3,
    minPolarAngle: Math.PI / 2.5,
    maxPolarAngle: Math.PI / 1.8,
    minAzimuthAngle: -Math.PI / 6,
    maxAzimuthAngle: Math.PI / 6,
    minDistance: 2,
    maxDistance: 15,
  },
};

export const NAV_TARGETS = [
  { id: 'about', label: 'About', color: COLORS.PRIMARY },
  { id: 'work', label: 'Work', color: COLORS.SECONDARY },
  { id: 'contact', label: 'Contact', color: COLORS.ACCENT },
];

export const ANIMATION_TIMINGS = {
  TARGET_HIT_DURATION: 1200,
  RESET_DELAY: 600,
  TOAST_REMOVE_DELAY: 1600,
  COLLISION_RESET_DELAY: 400,
};

export const TRAJECTORY_CONFIG = {
  STEPS: 12,
  STEP_TIME: 0.06,
};

